import {RouterModule, Routes} from '@angular/router';
import {NgModule} from '@angular/core';
import {PageNotFoundComponent} from './auth/page-not-found/page-not-found.component';
import {LoginPageComponent} from './auth/login-page/login-page.component';
import {AuthGuard} from './auth/auth-guard.service';
import {HomeComponent} from './home/home.component';
import {TypesComponent} from './types/types.component';
import {typesResolver} from './types/types.resolve';
import {statusesResolver} from './statuses/statuses/statuses.resolve';
import {PrioritiesComponent} from './priorities/priorities.component';
import {prioritiesResolver} from './priorities/priorities.resolve';
import {AreasComponent} from './areas/areas.component';
import {areasResolver} from './areas/areas.resolve';
import {ProductCategoriesComponent} from './product-categories/product-categories.component';
import {productCategoriesResolver} from './product-categories/product-categories.resove';
import {BranchAdminsComponent} from './branch-admins/branch-admins.component';
import {BranchesComponent} from './branches/branches.component';
import {branchesResolver} from './branches/branches.resolver';
import {DepartmentsComponent} from './departments/departments.component';
import {FormTypesComponent} from './form-types/form-types.component';
import {fromTypesResolver} from './form-types/form-types.resolver';
import {ChainsComponent} from './chains/chains.component';
import {chainsResolver} from './chains/chains.resolver';
import {ChainAdminsComponent} from './chain-admins/chain-admins.component';
import {UserAttributesComponent} from './user-attributes/user-attributes.component';
import {userAttributesResolver} from './user-attributes/user-attributes.resolver';
import {InstallationAttributesComponent} from './installation-attributes/installation-attributes.component';
import {installationAttributesResolver} from './installation-attributes/installation-attribute.resolver';
import {StatusesOverviewComponent} from './statuses/statuses-overview/statuses-overview.component';


import {NEW_UI_FORM_FIELD_DEFAULTS} from './shared/styles/new-ui-form-field';

const appRoutes: Routes = [
  {path: '', canActivate: [AuthGuard], component: HomeComponent, pathMatch: 'full'},
  {path: 'home', canActivate: [AuthGuard], component: HomeComponent},
  {path: 'login', component: LoginPageComponent},
  {
    path: 'areas',
    canActivate: [AuthGuard],
    providers: [NEW_UI_FORM_FIELD_DEFAULTS],
    component: AreasComponent,
    resolve: {
      areas: areasResolver
    }
  },
  {
    path: 'branches',
    canActivate: [AuthGuard],
    providers: [NEW_UI_FORM_FIELD_DEFAULTS],
    component: BranchesComponent,
    resolve: {
      branches: branchesResolver
    }
  },
  {
    path: 'branch-admins',
    canActivate: [AuthGuard],
    providers: [NEW_UI_FORM_FIELD_DEFAULTS],
    runGuardsAndResolvers: 'always',
    component: BranchAdminsComponent,
  },
  {
    path: 'types',
    canActivate: [AuthGuard],
    providers: [NEW_UI_FORM_FIELD_DEFAULTS],
    component: TypesComponent,
    resolve: {
      types: typesResolver
    }
  },
  {
    path: 'statuses',
    canActivate: [AuthGuard],
    providers: [NEW_UI_FORM_FIELD_DEFAULTS],
    component: StatusesOverviewComponent,
    resolve: {
      statuses: statusesResolver
    }
  },
  {
    path: 'priorities',
    canActivate: [AuthGuard],
    providers: [NEW_UI_FORM_FIELD_DEFAULTS],
    component: PrioritiesComponent,
    resolve: {
      priorities: prioritiesResolver
    }
  },
  {
    path: 'departments',
    canActivate: [AuthGuard],
    providers: [NEW_UI_FORM_FIELD_DEFAULTS],
    component: DepartmentsComponent,
  },
  {
    path: 'formtypes',
    canActivate: [AuthGuard],
    providers: [NEW_UI_FORM_FIELD_DEFAULTS],
    component: FormTypesComponent,
    resolve: {
      formtypes: fromTypesResolver
    }
  },
  {
    path: 'categories',
    canActivate: [AuthGuard],
    providers: [NEW_UI_FORM_FIELD_DEFAULTS],
    component: ProductCategoriesComponent,
    resolve: {
      categories: productCategoriesResolver
    }
  },
  {
    path: 'chains',
    canActivate: [AuthGuard],
    providers: [NEW_UI_FORM_FIELD_DEFAULTS],
    component: ChainsComponent,
    resolve: {
      chains: chainsResolver
    }
  },
  {
    path: 'chain-admins',
    canActivate: [AuthGuard],
    providers: [NEW_UI_FORM_FIELD_DEFAULTS],
    component: ChainAdminsComponent,
  },
  {
    path: 'user-attributes',
    canActivate: [AuthGuard],
    providers: [NEW_UI_FORM_FIELD_DEFAULTS],
    component: UserAttributesComponent,
    resolve: {
      userAttributes: userAttributesResolver
    }
  },
  {
    path: 'installation-attributes',
    canActivate: [AuthGuard],
    providers: [NEW_UI_FORM_FIELD_DEFAULTS],
    component: InstallationAttributesComponent,
    resolve: {
      installationAttributes: installationAttributesResolver
    }
  },
  {path: 'not-found', component: PageNotFoundComponent},
  {path: '**', redirectTo: '/not-found'}
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      onSameUrlNavigation: 'reload'
    })
  ],
  exports: [
    RouterModule
  ]
})
export class AppRoutingModule {

}
